export const SectionHeading = ({ eyebrow, title, id, light = false }) => (
  <div className="mb-10" id={id}>
    <span className="eyebrow block mb-3">{eyebrow}</span>
    <h2 className="text-h2" style={light ? { color: "#fff" } : { color: "var(--navy-700)" }}>
      {title}
    </h2>
    <div
      className="mt-4"
      style={{ height: 2, width: 64, background: light ? "#fff" : "var(--navy-700)" }}
    />
  </div>
);
